import { botClient, makeServicePlugin, BaseModel } from '@/bot'
import moment from 'moment'

class Action extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Action'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: "",
      description: "",
      trigger: {
        enabled: true
      },
      actions: {
        log: false,
        remove: false,
        approve: false,
        forward: false
      },
      elaborator_id: null,
      steps: [],
      trigger_groups: [],
      trigger_at: null,
      forward_groups: [],
      forward_group_conditions: {},
      properties: {
        icon: "",
        hidden: false
      },
      members_only: true
    }
  }
}

const servicePath = 'actions'
const servicePlugin = makeServicePlugin({
  Model: Action,
  service: botClient.service(servicePath),
  servicePath
})

const dateTimeToUTC = (ctx) => {
  let { data } = ctx

  if (data.trigger && data.trigger.date && data.trigger.time) {
    data.trigger_at = moment(`${data.trigger.date} ${data.trigger.time}`).utc().format()
  }
  return ctx
}

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [dateTimeToUTC],
    update: [],
    patch: [dateTimeToUTC],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin